module.exports = __webpack_public_path__ + "img/expostyle_9312_brick_red.f984295a.jpg";